module.exports = __webpack_public_path__ + "static/media/Shop button.9a6f099f.webp";